<template>
  <el-dialog custom-class="medium-dialog" title="唯一码扫码" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true">
    <div class="search-content">
      <p style="text-align: right">总数：{{totalnumber}}</p>
      <el-table
        :data="scancodes"
        size="mini"
        stripe
        border
        style="width: 100%;">
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          label="序号"
          width="50">
        </el-table-column>
        <el-table-column
          prop="seedcode"
          label="编码"
          align="left" width="140" :show-overflow-tooltip="true"
          header-align="center">
          <template slot-scope="scope">
            <span v-if="isshowqr?(seedcode==scope.row.seedcode):true">{{scope.row.seedcode}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="seedname"
          label="名称"
          align="left"
          header-align="center">
        </el-table-column>
        <el-table-column
          prop="totalnumber"
          label="数量"
          align="center"
          width="50"
          header-align="center">
        </el-table-column>
        <el-table-column
          prop="goodsbarcode"
          label="唯一码"
          align="center"
          width="200"
          header-align="center">
          <template slot-scope="scope">
            <el-input style="width: 100%" size="small" v-model="scope.row.goodsbarcode"
                      :disabled="!isshowqr"
                      :ref='scope.row.id'
                      onfocus="this.select()"
                      @keyup.enter.native="validateCounts(scope.row,scope.$index, $event)"
                      @keyup.down.native="validateCounts(scope.row,scope.$index, $event)"
                      @keyup.up.native="validateCounts(scope.row,scope.$index, $event)"
                      @change="scancodenumber(scope.row,scope.$index)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="80"
          header-align="center"
          v-if="isshowqr"
          align="center"
        >
          <template slot-scope="scope">
            <el-button @click="deletescancode(scope.$index, scope.row)" type="danger"
                       size="small">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogFormVisible=false">取 消</el-button>
      <el-button type="primary" @click="initializing" v-if="isshowqr">清除</el-button>
      <el-button type="primary" @click="saveData" v-if="isshowqr">确认</el-button>

    </div>
  </el-dialog>
</template>

<script>
  import {listData, weiyimalist} from '@/api/set/jxcstoregoodsbarcode';

  export default {
    name: "ScanCode",
    data() {
      return {
        scancodes: [],
        oldscancodes: [],//初始化用
        dialogFormVisible: false,
        totalnumber: 0,//总数
        number: 0,//最多扫唯一码数量
        isshowqr: true,//控制确定按钮是否显示 false查看采购单  true 填写入库单
        seedcode: '',
        noadd: true,//控制扫重复码后不添加行
        onlyonecodes: [],//用来判断不同商品里是否有相同唯一码
      }
    },
    methods: {
      saveData() {
        //判断唯一码是否唯一
        if (this.scancodes.length > 0) {
          var scancodelist = JSON.parse(JSON.stringify(this.scancodes))
          for (let i in scancodelist) {
            for (let j in this.scancodes) {
              if (scancodelist[i].id != this.scancodes[j].id && scancodelist[i].goodsbarcode == this.scancodes[j].goodsbarcode) {
                this.$message({
                  message: '唯一码不可相同',
                  type: 'error'
                })
                this.$refs[Object.keys(this.$refs)[scancodelist[i].id]].focus();
                return
              }
            }
          }
        }
        this.dialogFormVisible = false
        this.$emit("scancodeedit", this.scancodes, this.totalnumber)
      },
      show(scancodes, number, seedcode, isshowqr, onlyonecodes) {
        this.initData()
        this.number = number
        this.seedcode = seedcode
        this.dialogFormVisible = true
        this.isshowqr = isshowqr
        this.onlyonecodes = onlyonecodes
        if (!isshowqr) {
          listData({inordernum: scancodes[0].erpserial}).then(response => {
            var tableData = response.data.obj
            if (tableData.length > 0) {
              for (let i in tableData) {
                var obj = {}
                obj.seedcode = tableData[i].seedcode
                obj.seedname = tableData[i].seedname
                obj.totalnumber = 1
                obj.goodsbarcode = tableData[i].goodsbarcode
                this.scancodes.push(obj)
              }
              //重新计算总数
              for (let i in this.scancodes) {
                if (this.scancodes[i].goodsbarcode) {
                  ++this.totalnumber
                }
              }
            }
          })
        } else {
          this.scancodes = scancodes
          this.oldscancodes = JSON.parse(JSON.stringify(scancodes))
          //重新计算总数
          for (let i in this.scancodes) {
            if (this.scancodes[i].goodsbarcode) {
              ++this.totalnumber
            }
          }
          this.$nextTick(() => {
            this.$refs[Object.keys(this.$refs)[0]].focus();
          })
        }


      },
      //删除
      deletescancode(index, row) {
        if (this.scancodes.length > 1) {
          this.scancodes.splice(index, 1)
          //唯一码为空时，删除不减总数
          if (row.goodsbarcode)
            this.totalnumber--;
        } else {
          this.$message({
            message: '最后一行不能删除',
            type: 'warning'
          });
        }
      },
      //change事件 扫码增加 并计算总数
      scancodenumber(row, index) {
        this.noadd = true
        var obj = JSON.parse(JSON.stringify(row))
        obj.goodsbarcode = ''
        weiyimalist({goodsbarcode: row.goodsbarcode, formtype: 32}).then(response => {
          if (response.data.code == 1) {
            this.noadd = false
            row.goodsbarcode = ''
            this.$confirm(response.data.msg, '提示', {
              confirmButtonText: '确定',
              type: 'warning'
            }).then(() => {
              this.$message({
                type: 'info',
                message: '请重新扫码'
              });
              this.onlyonecode = ''
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '请重新扫码'
              });
            });
            return
          } else {
            //这里判断的不同商品里是否有相同唯一码
            for (let i in this.onlyonecodes) {
              if (row.goodsbarcode == this.onlyonecodes[i].goodsbarcode) {
                row.goodsbarcode = ''
                this.$message({
                  type: 'error',
                  message: '与' + row.seedname + '唯一码相同，请重新扫码！'
                })
                this.noadd = false
                this.$refs[Object.keys(this.$refs)[row.id]].focus();
                return
              }
            }
            //判断唯一码是否唯一
            for (let i in this.scancodes) {
              if (this.scancodes[i].goodsbarcode != undefined && row.id != this.scancodes[i].id && row.goodsbarcode == this.scancodes[i].goodsbarcode) {
                row.goodsbarcode = ''
                this.$message({
                  type: 'error',
                  message: '唯一码不可重复'
                })
                this.noadd = false
                this.$refs[Object.keys(this.$refs)[row.id]].focus();
                return
              }
            }
            //计算总数
            if (this.scancodes.length > 0) {
              this.totalnumber = 0
              for (let i in this.scancodes) {
                if (this.scancodes[i].goodsbarcode) {
                  ++this.totalnumber
                }
              }
            }
            if ((this.number == index + 1) || this.number == this.scancodes.length) {
              this.$message({
                message: '已到达入库数量' + this.number,
                type: 'warning'
              })
              return
            }
            this.scancodes.splice(index + 1, 0, obj)
          }
        })
      },
      //回车跳入下一行  上下方向键
      validateCounts(row, index, e) {
        setTimeout(() => {
          var keyCode = e.keyCode || e.which || e.charCode;
          if (keyCode == 40 || keyCode === 13) {//回车，下方向键
            if (this.noadd) {
              this.$refs[row.id].blur()
              if (this.scancodes.length - 1 === index) {
                index = -1
              }
              this.$refs[Object.keys(this.$refs)[index + 1]].focus();
            }
          } else if (keyCode == 38) {//上方向键
            this.$refs[row.id].blur()
            if (index === 0) {
              index = this.scancodes.length
            }
            this.$refs[Object.keys(this.$refs)[index - 1]].focus();
          }
        }, 100)
      },
      //给scancodes 添加 id，共回车使用
      indexMethod(index) {
        this.scancodes[index].id = index
        return index + 1;
      },
      //初始化 唯一码
      initializing() {
        this.onlyonecodes = []
        this.oldscancodes = []
        this.totalnumber = 0
        //清楚按钮
        var initform = {}
        initform.seedcode = this.scancodes[0].seedcode
        initform.seedname = this.scancodes[0].seedname
        initform.cangkucode = this.scancodes[0].cangkucode
        initform.erpserial = this.scancodes[0].erpserial
        initform.totalnumber = 1
        initform.goodsbarcode = ''
        this.oldscancodes.push(initform)
        this.scancodes = JSON.parse(JSON.stringify(this.oldscancodes))
        this.$emit('clearscancode', this.seedcode)
      },
      //初始化页面所有数据
      initData() {
        this.scancodes = []
        this.oldscancodes = []
        this.totalnumber = 0
        this.seedcode = ''
      }
      ,
    },
    mounted() {
    }
    ,
    components: {}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/ScanCode.vue